import { createAtomWithSafeStorage } from "@/utils/atom/atomStorageUtil"

export type MarketingContext = {
  utm_source?: string | null
  utm_medium?: string | null
  utm_campaign?: string | null
  utm_term?: string | null
  utm_content?: string | null
  gclid?: string | null
  fbclid?: string | null
  ttclid?: string | null
  twclid?: string | null
  referrer?: string | null
  landing_page?: string | null
  session_id?: string | null
  session_start?: number | null
  session_start_iso?: string | null
  user_id?: string | number | null
  device_type?: "Mobile" | "Tablet" | "Desktop" | string | null
  browser_ua?: string | null
  os?: "Windows" | "MacOS" | "Linux" | "Android" | "iOS" | string | null
  screen_resolution?: string | null
  language?: string | null
  timezone?: string | null
  location?: {
    country?: string | null
    city?: string | null
    lat?: number | null
    lng?: number | null
  } | null
  engagement?: {
    time_on_page_ms?: number | null
    max_scroll_pct?: number | null
  } | null
}

const initialMarketingContext: MarketingContext = {
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_term: null,
  utm_content: null,
  gclid: null,
  fbclid: null,
  ttclid: null,
  twclid: null,
  referrer: null,
  landing_page: null,
  session_id: null,
  session_start: null,
  session_start_iso: null,
  user_id: null,
  device_type: null,
  browser_ua: null,
  os: null,
  screen_resolution: null,
  language: null,
  timezone: null,
  location: null,
  engagement: null,
}

export const marketingContextAtom = createAtomWithSafeStorage<MarketingContext>(
  "marketing_context",
  initialMarketingContext,
)